// IMPORTS
// Modules
import $ from 'jquery';
import { useEffect, useState } from 'react';
// Assets
import './../scss/OHSMultiTab.scss';


// COMPONENT
export default function OHSMultiTab (props) {
   // States and Variables
   const containerID = 'ohsmultitab-' + Math.floor(Math.random() * 999999);
   const [activeTab, setActiveTab] = useState(0);

   // Listeners
   useEffect(function () {
      toggleTab(activeTab);
   }, [activeTab])

   // Functions
   const toggleTab = function (index) {
      // Mark Previous Tab with Class
      $(".ohsmultitab-previoustab").removeClass('ohsmultitab-previoustab');
      $(".ohsmultitab-activetab").addClass('ohsmultitab-previoustab');

      // Process Tabs and Content
      $("#" + containerID + "-content").children().each(function () {
         // Variables
         let temp = $(this).data('ohsmultitabindex');

         // Format Tab
         $("#" + containerID + "-header").children().each(function () {
            let tab = $(this).data('ohsmultitabindex');
            if (tab == index) {
               $(this).addClass('ohsmultitab-activetab');
            } else {
               $(this).removeClass('ohsmultitab-activetab');
            }
         });
         
         // Display Desired Tab Content
         if (temp == index) {
            $(this).show();
         } else {
            $(this).hide();
         }
      });
   }
   
   // Component
   return (
      <div id={props.id} className='ohsmultitab'>
         <div id={`${containerID}-header`} className='ohsmultitab-header'>
            {props.content && props.content.length > 0 && props.content.map(function (tab, i) {
               return (
                  <div key={`${containerID}-header-${i}`} data-ohsmultitabindex={i} className={i === activeTab ? "ohsmultitab-activetab" : undefined} onClick={() => {setActiveTab(i);}}>
                     <p>{tab.title}</p>
                  </div>
               );
            })}
            <div className='ohsmultitab-header-endspacer'></div>
         </div>
         <div id={`${containerID}-content`} className='ohsmultitab-content'>
            {props.content && props.content.length > 0 && props.content.map(function (item, i) {
               return (
                  <div key={`${containerID}-content-${i}`} data-ohsmultitabindex={i} style={i !== activeTab ? {'display': 'none'} : {}}>
                     {item.content}
                  </div>
               );
            })}
         </div>
      </div>
   );
}